import { getHeaders } from '../xhrRequest';
import { createAction } from 'redux-api-middleware';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const sendLogError = data => createAction({
    types: [
        LOGIN,
        {
            type: LOGIN_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return json;
                });
            }
        },
        LOGIN_FAILURE
    ],
    endpoint: `/api/log`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});
